import React, { useMemo, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

function getStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default function ProtectedRoute({ children, permission }) {
  const token = localStorage.getItem("authToken");
  const [user, setUser] = useState(() => getStoredUser());

  useEffect(() => {
    const handleStorage = () => {
      setUser(getStoredUser());
    };
    window.addEventListener("storage", handleStorage);
    // Also listen for custom storage update events
    window.addEventListener("userUpdated", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("userUpdated", handleStorage);
    };
  }, []);

  if (!token) {
    return <Navigate to="/server-login-584" replace />; // Redirect to login page if no token
  }

  if (permission) {
    // Only show if permission is explicitly enabled (value === 1)
    const hasPermission = user && Number(user[permission]) === 1;
    if (!hasPermission) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
